<div class="job-details-container">
    <ng-container *ngIf="!isLoading; else skeletonLoader">
        <!-- Back Link -->
        <a class="back-link" (click)="goBack()">
            <i class="bi bi-arrow-left"></i>
            <span>Back</span>
        </a>

        <!-- Header Section -->
        <div class="job-header-section">
            <div class="job-header-info">
                <h4 class="d-flex align-items-center gap-3">
                    {{ roundDetails?.round?.job_role }}

                    <!-- Status Badge with Dropdown - Only allow updates if in Draft -->
                    <div class="dropdown d-inline-block">
                        <span class="status-badge" [ngClass]="[
                            isExpired(roundDetails?.round) ? 'status-expired' : (roundDetails?.round?.status?.toLowerCase() === 'active' ? 'status-active' : 'bg-light text-muted')
                        ]">
                            <ng-container *ngIf="isExpired(roundDetails?.round); else normalStatus">
                                <i class="bi bi-calendar-x me-1"></i> Expired
                            </ng-container>
                            <ng-template #normalStatus>
                                {{ roundDetails?.round?.status | titlecase }}
                            </ng-template>
                        </span>
                    </div>
                </h4>
                <div class="job-header-meta">
                    <i class="bi bi-calendar-event"></i>
                    <span>Created on {{ roundDetails?.round?.created_at | date: 'MMMM dd, yyyy' }}</span>
                </div>
            </div>

            <ng-container *ngIf="!isExpired(roundDetails?.round); else expiredRoundLabel">
                <div class="d-flex align-items-center gap-2">
                    <button type="button" class="btn btn-outline-secondary px-4 py-2 rounded-pill d-flex align-items-center gap-2 fw-bold shadow-sm"
                        style="border-color: #e2e8f0;"
                        (click)="openExtendExpiryModal()" title="Extend Expiry">
                        <i class="bi bi-calendar-plus"></i>
                        <span>Extend Expiry</span>
                    </button>
                    <button type="button" class="test px-4 py-2 rounded-pill d-flex align-items-center gap-2 fw-bold shadow-sm"
                        (click)="exportCandidatesReport()" [disabled]="isExporting" title="Download Candidates">
                        <i class="bi" [ngClass]="isExporting ? 'bi-hourglass-split' : 'bi-download'"></i>
                        <span>{{ isExporting ? 'Downloading...' : 'Download Candidates' }}</span>
                    </button>
                    <button type="button" (click)="openInviteModal()"
                        class="btn btn-primary-gradient px-4 py-2 rounded-pill d-flex align-items-center gap-2 fw-bold shadow-sm">
                        <i class="bi bi-person-plus-fill"></i>
                        <span>Add & Invite Candidates</span>
                    </button>
                </div>
            </ng-container>
            <ng-template #expiredRoundLabel>
                <div class="d-flex align-items-center gap-2">
                    <div
                        class="d-flex align-items-center gap-2 text-danger fw-bold py-2 px-3 bg-danger bg-opacity-10 rounded-pill border border-danger">
                        <i class="bi bi-exclamation-circle-fill"></i>
                        <span>Round Expired</span>
                    </div>
                    <button type="button" class="btn btn-outline-danger px-4 py-2 rounded-pill d-flex align-items-center gap-2 fw-bold shadow-sm"
                        (click)="openExtendExpiryModal()" title="Extend Expiry">
                        <i class="bi bi-calendar-plus"></i>
                        <span>Extend Expiry</span>
                    </button>
                    <button type="button" class="test px-4 py-2 rounded-pill d-flex align-items-center gap-2 fw-bold shadow-sm"
                        (click)="exportCandidatesReport()" [disabled]="isExporting" title="Download Candidates">
                        <i class="bi" [ngClass]="isExporting ? 'bi-hourglass-split' : 'bi-download'"></i>
                        <span>{{ isExporting ? 'Downloading...' : 'Download Candidates' }}</span>
                    </button>
                </div>
            </ng-template>
        </div>

        <!-- Stats Row -->
        <div class="stats-row">
            <div class="detail-stat-card">
                <div class="stat-content">
                    <span class="stat-label">Total</span>
                    <span class="stat-value">{{ roundDetails?.statistics?.total || 0 }}</span>
                </div>
                <div class="stat-icon icon-purple">
                    <i class="bi bi-people"></i>
                </div>
            </div>
            <div class="detail-stat-card">
                <div class="stat-content">
                    <span class="stat-label">Invited</span>
                    <span class="stat-value">{{ roundDetails?.statistics?.invited || 0 }}</span>
                </div>
                <div class="stat-icon icon-blue">
                    <i class="bi bi-envelope"></i>
                </div>
            </div>
            <div class="detail-stat-card">
                <div class="stat-content">
                    <span class="stat-label">In Progress</span>
                    <span class="stat-value">{{ roundDetails?.statistics?.in_progress || 0 }}</span>
                </div>
                <div class="stat-icon icon-orange">
                    <i class="bi bi-clock"></i>
                </div>
            </div>
            <div class="detail-stat-card">
                <div class="stat-content">
                    <span class="stat-label">Completed</span>
                    <span class="stat-value">{{ roundDetails?.statistics?.completed || 0 }}</span>
                </div>
                <div class="stat-icon icon-purple">
                    <i class="bi bi-check2-circle"></i>
                </div>
            </div>
            <div class="detail-stat-card">
                <div class="stat-content">
                    <span class="stat-label">Passed</span>
                    <span class="stat-value text-success">{{ roundDetails?.statistics?.passed || 0 }}</span>
                </div>
                <div class="stat-icon icon-green">
                    <i class="bi bi-check-lg"></i>
                </div>
            </div>
            <div class="detail-stat-card">
                <div class="stat-content">
                    <span class="stat-label">Failed</span>
                    <span class="stat-value text-danger">{{ roundDetails?.statistics?.failed || 0 }}</span>
                </div>
                <div class="stat-icon icon-red">
                    <i class="bi bi-x-lg"></i>
                </div>
            </div>
        </div>

        <div class="round-content-layout" [class.sidebar-collapsed]="isSidebarCollapsed">
            <!-- Sidebar Column -->
            <div class="round-left-sidebar" [class.collapsed]="isSidebarCollapsed">
                <!-- Collapsed Slim Icon Rail (like left navigation bar) -->
                <div class="collapsed-sidebar-rail" *ngIf="isSidebarCollapsed">
                    <button type="button" class="rail-toggle-btn" (click)="toggleSidebar()" title="Expand sidebar">
                        <i class="bi bi-chevron-right"></i>
                    </button>
                    <div class="rail-divider"></div>
                    <button type="button" class="rail-nav-btn" (click)="expandSidebar('jobDetailsCard')" title="Job Details">
                        <i class="bi bi-file-earmark-text"></i>
                    </button>
                    <button type="button" class="rail-nav-btn" (click)="expandSidebar('interviewSettingsCard')" title="Interview Settings">
                        <i class="bi bi-sliders"></i>
                    </button>
                    <button type="button" class="rail-nav-btn" [class.copied]="copied" (click)="onCopy()" [title]="copied ? 'Copied!' : 'Copy Interview Link'">
                        <i [class]="copied ? 'bi bi-check-lg text-success' : 'bi bi-link-45deg'"></i>
                    </button>
                </div>

                <!-- Expanded 3 Cards -->
                <ng-container *ngIf="!isSidebarCollapsed">
                    <!-- Job Details Card -->
                    <div class="sidebar-card" id="jobDetailsCard">
                        <div class="d-flex align-items-center justify-content-between mb-3">
                            <div class="d-flex align-items-center gap-2">
                                <i class="bi bi-file-earmark-text text-primary"></i>
                                <h5 class="mb-0">Job Details</h5>
                            </div>
                            <button type="button" class="sidebar-collapse-btn" (click)="toggleSidebar()" title="Collapse sidebar">
                                <i class="bi bi-chevron-left"></i>
                            </button>
                        </div>

                        <span class="card-label">Job Description</span>
                        <div class="description-text">{{ roundDetails?.round?.job_description }}</div>

                        <div class="questions-box" *ngIf="roundDetails?.round?.questions?.length">
                            <div class="questions-header">
                                <i class="bi bi-question-circle-fill"></i>
                                <span>QUESTIONS ({{ roundDetails?.round?.questions?.length || 0 }})</span>
                            </div>
                            <div class="question-list">
                                <div *ngFor="let q of roundDetails?.round?.questions; let i = index" class="question-item">
                                    <span class="question-num">{{ i + 1 }}</span>
                                    <span>{{ q }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="info-row">
                            <span class="info-label">Department</span>
                            <span class="info-value">{{ roundDetails?.round?.department }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Experience</span>
                            <span class="info-value">{{ roundDetails?.round?.experience }} </span>
                        </div>

                        <span class="card-label mt-4">Skills Required</span>
                        <div class="skill-pills">
                            <span *ngFor="let skill of roundDetails?.round?.skills" class="skill-pill">
                                {{ skill }}
                            </span>
                        </div>
                    </div>

                    <!-- Interview Settings -->
                    <div class="sidebar-card" id="interviewSettingsCard">
                        <div class="d-flex align-items-center gap-2 mb-3">
                            <i class="bi bi-sliders text-primary"></i>
                            <h5 class="mb-0">Interview Settings</h5>
                        </div>
                        <div class="info-row align-items-center">
                            <div class="d-flex align-items-center gap-2">
                                <i class="bi bi-clock text-primary"></i>
                                <span class="info-label">Duration</span>
                            </div>
                            <span class="info-value">{{ roundDetails?.round?.total_duration_minutes }} minutes</span>
                        </div>
                        <div class="info-row align-items-center">
                            <div class="d-flex align-items-center gap-2">
                                <i class="bi bi-bullseye text-primary"></i>
                                <span class="info-label">Passing Score</span>
                            </div>
                            <span class="info-value">{{ roundDetails?.round?.passing_score }}%</span>
                        </div>
                        <div class="info-row align-items-center">
                            <div class="d-flex align-items-center gap-2">
                                <i class="bi bi-arrow-repeat text-primary"></i>
                                <span class="info-label">No of Attempts</span>
                            </div>
                            <span class="info-value">{{ roundDetails?.round?.maximum_attempts || 1 }}</span>
                        </div>
                        <div class="info-row align-items-center">
                            <div class="d-flex align-items-center gap-2">
                                <i class="bi bi-translate text-primary"></i>
                                <span class="info-label">Multi-language</span>
                            </div>
                            <span class="info-value">{{ roundDetails?.round?.enable_multilanguage ? 'Enabled' : 'Disabled'
                                }}</span>
                        </div>
                    </div>

                    <!-- Interview Link -->
                    <div class="sidebar-card" id="interviewLinkCard">
                        <div class="d-flex align-items-center gap-2 mb-3">
                            <i class="bi bi-link-45deg text-primary fs-5"></i>
                            <h5 class="mb-0">Interview Link</h5>
                        </div>
                        <div class="link-input-group">
                            <input type="text" [value]="roundDetails?.screening_access_link" readonly>
                            <button class="copy-icon-btn" (click)="onCopy()">
                                <i [class]="copied ? 'bi bi-check-lg text-success' : 'bi bi-copy'"></i>
                            </button>
                        </div>
                        <p class="text-muted small mb-0">Share this link with invited candidates.</p>
                    </div>
                </ng-container>
            </div>

            <!-- Table Column -->
            <div class="round-main-content">
                <div class="candidates-table-card">
                    <div
                        class="table-header d-flex flex-column flex-xl-row justify-content-between align-items-start align-items-xl-center gap-3">
                        <div>
                            <h5>Candidates</h5>
                            <p>{{ filteredAndSortedCandidates.length || 0 }} candidates</p>
                        </div>
                        <div class="filter-controls d-flex flex-column flex-md-row gap-3 w-100 justify-content-xl-end align-items-center">
                            <button type="button" class="btn-filters-toggle" (click)="openAdvancedFiltersModal()"
                                [class.has-active-filters]="activeFiltersCount > 0">
                                <i class="bi bi-sliders"></i>
                                <span>Filters</span>
                                <span class="active-filter-badge" *ngIf="activeFiltersCount > 0">{{ activeFiltersCount }}</span>
                                <span class="active-filter-clear-btn" *ngIf="activeFiltersCount > 0"
                                    (click)="onClearFiltersFromButton($event)" title="Clear all filters">
                                    <i class="bi bi-x"></i>
                                </span>
                            </button>

                            <div class="drp-wrapper">
                                <!-- Backdrop: closes picker on outside click -->
                                <div class="drp-backdrop" *ngIf="showDatePicker" (click)="showDatePicker = false"></div>

                                <button class="drp-trigger" (click)="toggleDatePicker($event)"
                                    [class.drp-active]="pickerStartDate">
                                    <i class="bi bi-calendar3 drp-cal-icon"></i>
                                    <span class="drp-label">{{ pickerDisplayLabel }}</span>
                                    <i class="bi bi-chevron-down drp-chevron"></i>
                                </button>

                                <div class="drp-panel" *ngIf="showDatePicker" (click)="$event.stopPropagation()">
                                    <div class="drp-nav">
                                        <button class="drp-nav-btn" type="button" (click)="pickerPrevMonth()">
                                            <i class="bi bi-chevron-left"></i>
                                        </button>
                                        <span class="drp-month-label">{{ pickerMonthLabel }}</span>
                                        <button class="drp-nav-btn" type="button" (click)="pickerNextMonth()">
                                            <i class="bi bi-chevron-right"></i>
                                        </button>
                                    </div>

                                    <div class="drp-grid">
                                        <div class="drp-weekday" *ngFor="let wd of pickerWeekDays">{{ wd }}</div>
                                        <div *ngFor="let day of pickerCalendarDays" class="drp-day"
                                            [class.drp-empty]="!day" [class.drp-start]="pickerIsStart(day)"
                                            [class.drp-end]="pickerIsEnd(day)"
                                            [class.drp-in-range]="pickerIsInRange(day)"
                                            [class.drp-today]="pickerIsToday(day)" (click)="day && pickerSelectDay(day)"
                                            (mouseenter)="pickerHoverDate = day" (mouseleave)="pickerHoverDate = null">
                                            {{ day ? day.getDate() : '' }}
                                        </div>
                                    </div>

                                    <div class="drp-footer">
                                        <span class="drp-range-label">
                                            Select date range
                                            <strong *ngIf="pickerStartDate || pickerEndDate">&nbsp;{{ pickerDisplayLabel
                                                }}</strong>
                                        </span>
                                        <div class="drp-actions">
                                            <button type="button" class="drp-clear-btn"
                                                (click)="clearDatePicker()">Clear</button>
                                            <button type="button" class="drp-apply-btn" (click)="applyDatePicker()"
                                                [disabled]="!pickerStartDate">Apply</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="candidate-table">
                            <thead>
                                <tr>
                                    <th>Candidate</th>
                                    <th>Phone</th>
                                    <th>College</th>
                                    <th>Status</th>
                                    <th>Score</th>
                                    <th>Attempts</th>
                                    <th>Submitted Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let candidate of filteredAndSortedCandidates">
                                    <tr [class.candidate-row-expanded]="isAttemptsExpanded(candidate.id)">
                                        <td>
                                            <div class="candidate-info"
                                                [class.clickable]="candidate.attempts && candidate.attempts > 0"
                                                (click)="candidate.attempts && candidate.attempts > 0 ? toggleAttemptsRow(candidate.id, $event) : null">
                                                <span class="name">{{ candidate.name || 'Anonymous Candidate' }}</span>
                                                <span class="email">{{ candidate.email }}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <span class="phone-text">{{ candidate.phone || '-' }}</span>
                                        </td>
                                        <td>
                                            <span class="college-text">{{ candidate.college_name || '-' }}</span>
                                        </td>
                                        <td>
                                            <span class="status-pill"
                                                [ngClass]="candidate.is_passed ? 'pass' : (candidate.status === 'fail' ? 'fail' : 'bg-light text-muted')">
                                                {{ (candidate.is_passed ? 'Pass' : (candidate.status === 'fail' ? 'Fail' :
                                                candidate.status)) | titlecase }}
                                            </span>
                                        </td>
                                        <td>
                                            <span class="score-text">{{ candidate.score !== null && candidate.score !== undefined ? candidate.score : '-' }}</span>
                                        </td>
                                        <td>
                                            <ng-container *ngIf="candidate.attempts && candidate.attempts > 0; else noAttempts">
                                                <button type="button" class="attempts-pill-btn"
                                                    [class.expanded]="isAttemptsExpanded(candidate.id)"
                                                    (click)="toggleAttemptsRow(candidate.id, $event)"
                                                    title="View attempts history">
                                                    <span>{{ candidate.attempts }}</span>
                                                    <i class="bi" [ngClass]="isAttemptsExpanded(candidate.id) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                                                </button>
                                            </ng-container>
                                            <ng-template #noAttempts>
                                                <span class="empty-dash">-</span>
                                            </ng-template>
                                        </td>
                                        <td>
                                            <ng-container *ngIf="candidate.submitted_date; else noDate">
                                                <div class="submitted-date-box">
                                                    <div class="date-icon-wrapper">
                                                        <i class="bi bi-calendar2-check-fill"></i>
                                                    </div>
                                                    <div class="date-text-wrapper">
                                                        <span class="date-main">{{ candidate.submitted_date | date:'MMM dd,
                                                            yyyy' }}</span>
                                                        <span class="date-sub">{{ candidate.submitted_date | date:'h:mm a'
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </ng-container>
                                            <ng-template #noDate>
                                                <span class="empty-dash">-</span>
                                            </ng-template>
                                        </td>
                                        <td>
                                            <a class="view-report-link" *ngIf="candidate.status"
                                                (click)="viewCandidateReport(candidate)">
                                                View Report
                                            </a>
                                        </td>
                                    </tr>

                                    <!-- Expandable Attempts Sub-Table Row -->
                                    <tr class="attempts-expansion-row"
                                        *ngIf="isAttemptsExpanded(candidate.id) && candidate.attempts_history?.length">
                                        <td colspan="8" class="attempts-expansion-cell">
                                            <div class="attempts-subcard">
                                                <div class="attempts-subcard-header">
                                                    <span class="attempts-subcard-title">
                                                        {{ candidate.name || 'Anonymous Candidate' }} &mdash; Attempts
                                                    </span>
                                                    <span class="attempts-subcard-count">
                                                        {{ candidate.attempts }} {{ candidate.attempts === 1 ? 'attempt' : 'attempts' }}
                                                    </span>
                                                </div>

                                                <div class="table-responsive">
                                                    <table class="attempts-subtable">
                                                        <thead>
                                                            <tr>
                                                                <th>Attempt</th>
                                                                <th>Status</th>
                                                                <th>Score</th>
                                                                <th>Started</th>
                                                                <th>Ended</th>
                                                                <th>Time Spent</th>
                                                                <th>Submitted Date</th>
                                                                <th>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let attempt of candidate.attempts_history">
                                                                <td>
                                                                    <div class="attempt-num-cell">
                                                                        <span class="attempt-hash">#{{ attempt.attempt_number }}</span>
                                                                        <span class="latest-attempt-badge" *ngIf="attempt.is_latest">Latest</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <span class="status-pill"
                                                                        [ngClass]="attempt.is_passed ? 'pass' : (attempt.status === 'fail' ? 'fail' : 'bg-light text-muted')">
                                                                        {{ (attempt.is_passed ? 'Pass' : (attempt.status === 'fail' ? 'Fail' : attempt.status)) | titlecase }}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span class="score-text">{{ attempt.score !== null && attempt.score !== undefined ? attempt.score : '-' }}</span>
                                                                </td>
                                                                <td>
                                                                    <span class="attempt-time-text">{{ attempt.started_at || '-' }}</span>
                                                                </td>
                                                                <td>
                                                                    <span class="attempt-time-text">{{ attempt.ended_at || '-' }}</span>
                                                                </td>
                                                                <td>
                                                                    <ng-container *ngIf="attempt.time_spent; else noTimeSpent">
                                                                        <span class="time-spent-pill">
                                                                            <i class="bi bi-clock"></i>
                                                                            <span>{{ attempt.time_spent }}</span>
                                                                        </span>
                                                                    </ng-container>
                                                                    <ng-template #noTimeSpent>
                                                                        <span class="empty-dash">-</span>
                                                                    </ng-template>
                                                                </td>
                                                                <td>
                                                                    <ng-container *ngIf="attempt.submitted_date; else noAttemptDate">
                                                                        <div class="date-text-wrapper">
                                                                            <span class="date-main">{{ attempt.submitted_date | date:'MMM dd, yyyy' }}</span>
                                                                            <span class="date-sub">{{ attempt.submitted_date | date:'h:mm a' }}</span>
                                                                        </div>
                                                                    </ng-container>
                                                                    <ng-template #noAttemptDate>
                                                                        <span class="empty-dash">-</span>
                                                                    </ng-template>
                                                                </td>
                                                                <td>
                                                                    <button type="button" class="view-attempt-report-btn"
                                                                        (click)="viewCandidateReport(candidate, attempt)">
                                                                        View Report
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-template #skeletonLoader>
        <!-- Back Link Skeleton -->
        <div class="skeleton-box skeleton-text mb-4" style="width: 120px;"></div>

        <!-- Header Section Skeleton -->
        <div class="job-header-section mb-4">
            <div class="job-header-info w-100">
                <div class="d-flex align-items-center gap-3 w-100 mb-2">
                    <div class="skeleton-box skeleton-title w-50"></div>
                    <div class="skeleton-box skeleton-pill" style="width: 80px;"></div>
                </div>
                <div class="job-header-meta">
                    <div class="skeleton-box skeleton-text" style="width: 200px;"></div>
                </div>
            </div>
        </div>

        <!-- Stats Row Skeleton -->
        <div class="stats-row mb-4">
            <div class="detail-stat-card" *ngFor="let i of [1,2,3,4]">
                <div class="stat-content w-100">
                    <div class="skeleton-box skeleton-text mb-2" style="width: 60px;"></div>
                    <div class="skeleton-box skeleton-title" style="width: 40px;"></div>
                </div>
                <div class="skeleton-box" style="width: 36px; height: 36px; border-radius: 10px;"></div>
            </div>
        </div>

        <div class="row g-4">
            <div class="col-12 col-lg-4">
                <!-- Job Details Skeleton -->
                <div class="sidebar-card mb-4" *ngFor="let i of [1,2,3]">
                    <div class="skeleton-box skeleton-title mb-3" style="width: 120px;"></div>
                    <div class="skeleton-box skeleton-text w-100 mb-2"></div>
                    <div class="skeleton-box skeleton-text w-100 mb-2"></div>
                    <div class="skeleton-box skeleton-text w-75"></div>
                </div>
            </div>
            <div class="col-12 col-lg-8">
                <!-- Candidates Table Skeleton -->
                <div class="candidates-table-card p-4">
                    <div class="skeleton-box skeleton-title mb-2" style="width: 150px;"></div>
                    <div class="skeleton-box skeleton-text mb-4" style="width: 250px;"></div>

                    <div class="d-flex justify-content-between mb-3 border-bottom pb-2">
                        <div class="skeleton-box skeleton-text w-25"></div>
                        <div class="skeleton-box skeleton-text w-25"></div>
                        <div class="skeleton-box skeleton-text w-25"></div>
                    </div>
                    <div class="d-flex justify-content-between mb-4" *ngFor="let i of [1,2,3,4,5]">
                        <div class="skeleton-box skeleton-text w-25"></div>
                        <div class="skeleton-box skeleton-text w-25"></div>
                        <div class="skeleton-box skeleton-text w-25"></div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>

<!-- Add & Invite Candidates Modal -->
<div class="modal-backdrop-blur" *ngIf="showInviteModal">
    <div class="modal-window-card" style="max-width: 500px;">
        <div class="modal-header-simple">
            <div>
                <h2 class="modal-heading-text">Add & Invite Candidates</h2>
                <p class="modal-subheading-text">Enter email addresses to send interview invitations</p>
            </div>
            <button class="close-btn-ghost" (click)="closeInviteModal()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
        </div>

        <div class="modal-body-scrollable">
            <div class="form-group mb-2">
                <label class="form-label-bold">Candidate Emails *</label>
                <textarea class="form-input-styled" [(ngModel)]="inviteEmails" rows="5"
                    placeholder="email1@example.com, email2@example.com"></textarea>
            </div>
            <p class="help-text-muted">
                Each candidate will receive an email with the interview link and instructions.
            </p>
        </div>

        <div class="modal-footer-flex">
            <button class="btn-outline-ghost" (click)="closeInviteModal()">Cancel</button>
            <button class="btn-primary-purple-gradient d-flex align-items-center gap-2" (click)="sendInvitations()"
                [disabled]="isInviting">
                <i class="bi bi-person-plus-fill" *ngIf="!isInviting"></i>
                <span *ngIf="isInviting" class="spinner-border spinner-border-sm me-2" role="status"
                    aria-hidden="true"></span>
                {{ isInviting ? 'Sending...' : 'Send invitations' }}
            </button>
        </div>
    </div>
</div>

<!-- Extend Expiry Modal -->
<div class="modal-backdrop-blur" *ngIf="showExtendExpiryModal">
    <div class="modal-window-card" style="max-width: 420px; padding: 24px; border-radius: 16px;">
        <div class="modal-header-simple" style="padding-bottom: 16px; border-bottom: none; align-items: flex-start;">
            <div>
                <h2 class="modal-heading-text" style="font-size: 1rem; font-weight: 600; color: #1e293b; margin-bottom: 4px;">Extend link expiry</h2>
                <p class="modal-subheading-text" style="color: #64748b; font-size: 0.8rem; margin-bottom: 0;">{{ roundDetails?.round?.job_role || roundDetails?.round?.name || 'Job Round' }}</p>
            </div>
            <button class="close-btn-ghost" (click)="closeExtendExpiryModal()" style="background-color: #f1f5f9; border-radius: 8px; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; padding: 0;">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
        </div>

        <div class="modal-body-scrollable" style="padding-top: 0;">
            <div *ngIf="isExpired(roundDetails?.round)" style="background-color: #fef2f2; border-radius: 8px; padding: 12px; margin-bottom: 16px;">
                <div style="color: #ef4444; font-weight: 600; font-size: 0.9rem; margin-bottom: 4px;">This link has expired</div>
                <div style="color: #ef4444; font-size: 0.8rem; opacity: 0.9;">Expired on {{ roundDetails?.round?.valid_until | date: 'MMM d, yyyy, h:mm a' }}</div>
            </div>

            <div style="margin-bottom: 16px;">
                <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #334155; margin-bottom: 8px;">Quick extend</label>
                <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                    <button type="button" (click)="quickExtend(1)" 
                        [ngStyle]="selectedQuickExtend === 1 ? {'border-color': '#4a4a9c', 'color': '#4a4a9c', 'font-weight': '600', 'background-color': '#f8f8ff'} : {'border-color': '#e2e8f0', 'color': '#475569', 'font-weight': '500', 'background-color': 'white'}"
                        style="width: 50px; height: 20px; display: flex; align-items: center; justify-content: center; border: 1px solid; border-radius: 12px; font-size: 0.6rem; cursor: pointer; transition: all 0.2s; padding: 0;">+1 day</button>
                    
                    <button type="button" (click)="quickExtend(7)" 
                        [ngStyle]="selectedQuickExtend === 7 ? {'border-color': '#4a4a9c', 'color': '#4a4a9c', 'font-weight': '600', 'background-color': '#f8f8ff'} : {'border-color': '#e2e8f0', 'color': '#475569', 'font-weight': '500', 'background-color': 'white'}"
                        style="width: 50px; height: 20px; display: flex; align-items: center; justify-content: center; border: 1px solid; border-radius: 12px; font-size: 0.6rem; cursor: pointer; transition: all 0.2s; padding: 0;">+7 days</button>
                    
                    <button type="button" (click)="quickExtend(30)" 
                        [ngStyle]="selectedQuickExtend === 30 ? {'border-color': '#4a4a9c', 'color': '#4a4a9c', 'font-weight': '600', 'background-color': '#f8f8ff'} : {'border-color': '#e2e8f0', 'color': '#475569', 'font-weight': '500', 'background-color': 'white'}"
                        style="width: 50px; height: 20px; display: flex; align-items: center; justify-content: center; border: 1px solid; border-radius: 12px; font-size: 0.6rem; cursor: pointer; transition: all 0.2s; padding: 0;">+30 days</button>
                </div>
            </div>

            <div class="form-group mb-0">
                <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #334155; margin-bottom: 8px;">Or pick a date & time</label>
                <input type="datetime-local" [(ngModel)]="newExpiryDate" (ngModelChange)="selectedQuickExtend = null" [min]="minExpiryDate" class="form-input-styled" style="border: 1px solid #e2e8f0; border-radius: 8px; padding: 8px 12px; width: 100%; color: #334155; outline: none;">
            </div>

            <div *ngIf="newExpiryDate" style="background-color: #f0f9ff; border-radius: 8px; padding: 12px; margin-top: 16px;">
                <div style="color: #3b82f6; font-size: 0.75rem; font-weight: 500; margin-bottom: 4px;">New expiry</div>
                <div style="color: #1d4ed8; font-weight: 600; font-size: 0.95rem;">{{ newExpiryDate | date: 'MMM d, yyyy, h:mm a' }}</div>
            </div>
        </div>

        <div class="modal-footer-flex" style="border-top: none; padding-top: 24px; padding-bottom: 0;">
            <button class="btn-outline-ghost" (click)="closeExtendExpiryModal()" style="border: 1px solid #e2e8f0; color: #475569; border-radius: 8px; padding: 8px 16px; font-weight: 500;">Cancel</button>
            <button class="btn-primary-purple-gradient d-flex align-items-center gap-2" (click)="extendExpiry()"
                [disabled]="isExtending || !newExpiryDate" style="background: #312e81; border: none; border-radius: 8px; padding: 8px 24px; color: white; font-weight: 500;">
                <span *ngIf="isExtending" class="spinner-border spinner-border-sm me-2" role="status"
                    aria-hidden="true"></span>
                {{ isExtending ? 'Updating...' : 'Extend link' }}
            </button>
        </div>
    </div>
</div>

<!-- Report Warning Popup -->
<div class="report-warning-overlay" *ngIf="showReportWarningPopup" (click)="closeReportWarning()">
    <div class="report-warning-box" (click)="$event.stopPropagation()">
        <div class="report-warning-header">
            <h4>{{ reportWarningTitle }}</h4>
            <button class="close-btn" (click)="closeReportWarning()">✕</button>
        </div>
        <div class="report-warning-body">
            <div class="icon-wrapper" [ngClass]="reportWarningType === 'error' ? 'error' : 'info'">
                <i class="bi"
                    [ngClass]="reportWarningType === 'error' ? 'bi-exclamation-circle-fill' : 'bi-info-circle-fill'"></i>
            </div>
            <p>
                {{ reportWarningMessage }}
            </p>
        </div>
        <div class="report-warning-footer">
            <button class="btn-okay" (click)="closeReportWarning()">Okay</button>
        </div>
    </div>
</div>

<!-- Advanced Filters Modal -->
<div class="filter-backdrop" *ngIf="showAdvancedFilters" (click)="closeAdvancedFiltersModal()"></div>

<div class="filter-modal" *ngIf="showAdvancedFilters" (click)="$event.stopPropagation()" (keydown.enter)="onFilterEnter($event)">
    <div class="filter-modal-header">
        <h4>Advanced Filters</h4>
        <button type="button" class="close-btn" (click)="closeAdvancedFiltersModal()">✕</button>
    </div>

    <div class="filter-modal-body">
        <!-- Candidate Name -->
        <div class="filter-field">
            <label>Candidate Name</label>
            <input type="text" placeholder="Enter candidate name" [(ngModel)]="advancedFilters.name">
        </div>

        <!-- Candidate Email -->
        <div class="filter-field">
            <label>Candidate Email</label>
            <input type="text" placeholder="Enter candidate email" [(ngModel)]="advancedFilters.email">
        </div>

        <!-- Phone Number -->
        <div class="filter-field">
            <label>Phone Number</label>
            <input type="text" placeholder="Enter phone number" [(ngModel)]="advancedFilters.phone">
        </div>

        <!-- College -->
        <div class="filter-field">
            <label>College</label>
            <select [(ngModel)]="advancedFilters.college" class="filter-select">
                <option value="">All Colleges</option>
                <option *ngFor="let col of availableColleges" [value]="col">{{ col }}</option>
            </select>
        </div>

        <!-- Score (Min - Max) -->
        <div class="filter-field">
            <label>Score (%)</label>
            <div class="range-row">
                <input type="number" placeholder="Min" [(ngModel)]="advancedFilters.min_score" min="0" max="100">
                <input type="number" placeholder="Max" [(ngModel)]="advancedFilters.max_score" min="0" max="100">
            </div>
        </div>

        <!-- Status -->
        <div class="filter-field">
            <label>Status</label>
            <select [(ngModel)]="advancedFilters.status" class="filter-select">
                <option value="">All Status</option>
                <option value="Pass">Pass</option>
                <option value="Fail">Fail</option>
                <option value="Invited">Invited</option>
                <option value="In Progress">In Progress</option>
                <option value="Completed">Completed</option>
            </select>
        </div>
    </div>

    <div class="filter-actions">
        <button type="button" class="btn-filter-clear" (click)="clearAdvancedFilters()">Clear</button>
        <button type="button" class="btn-filter-apply" (click)="applyAdvancedFilters()">Apply Filters</button>
    </div>
</div>